const createMarker = function (
    location,
    markerThemeExtractor,
    currentMapTheme,
    hoverEnterLocation,
    hoverLeaveLocation,
    clickLocation,
    highlightLocation,
    map
) {
    var latLng = { lat: location.latitude, lng: location.longitude }
    var highlighted = highlightLocation == location
    var useMediumIcon = location.useMediumIcon
    var useBigIcon = location.useBigIcon

    let brand;
    if (currentMapTheme.value.name === 'totalkredit') {
        brand = undefined;
    } else if (location.isSparNord) {
        brand = 'spar-nord';
    } else {
        brand = 'nykredit';
    }

    var marker = new window.google.maps.Marker({
        position: latLng,
        map: map.value,
        title: location.name,
        icon: markerThemeExtractor(highlighted, useMediumIcon, useBigIcon, brand),
        ...currentMapTheme.value.markerOptions(brand),
    })

    marker.addListener('mouseover', function () {
        hoverEnterLocation(location)
    })

    marker.addListener('mouseout', function () {
        hoverLeaveLocation()
    })

    marker.addListener('click', function () {
        clickLocation(location)
    })

    return marker
}

export default createMarker